/**
 *
 * @module mediaPayload
 *
 */

/**
 *
 * @class MediaPayload
 * @implements {IMediaPayload}
 * @desc Represents the media payload response from the playlist service.
 *
 */
export default class MediaPayload {

    /**
     *
     * @param {Object} options
     * @param {String} options.completeStreamUri
     * @param {String} options.slideStreamUri
     * @param {Object} options.trackingInfo
     * @param {MediaPlayhead} options.playhead
     * @param {Object} options.attributes
     *
     */
    constructor(options) {

        const { completeStreamUri, slideStreamUri, trackingInfo, playhead, attributes, thumbnails } = options;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the "complete" media stream URL.
         * @note This URL can typically be supplied to a media player.
         *
         */
        this.completeStreamUri = completeStreamUri;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the "slide" media stream URL.
         * @note This URL can typically be supplied to a media player.
         *
         */
        this.slideStreamUri = slideStreamUri;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Gets additional information used to track the media.
         *
         */
        this.trackingInfo = trackingInfo;

        /**
         *
         * @access public
         * @type {MediaPlayhead}
         * @desc Gets playhead information from the previous playback session for the current user.
         *
         */
        this.playhead = playhead;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.attributes = attributes;

        /**
         *
         * @access public
         * @type {SDK.Services.Media.MediaThumbnailLinks}
         *
         */
        this.thumbnails = thumbnails;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/mediaPayload.js